import {
  Card,
  CardContent,
  Grid,
  Heading,
  Stack,
  Text,
} from "@generalapplications/ui";

import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { aboutPage } from "@/content/about";
import { formatText } from "@/app/common/functions/format/formatText";

/** The About page's argument, a card per point. */
export function AboutSections() {
  return (
    <RevealGroup>
      <Grid columns={{ base: 1, lg: 2 }} gap="xl">
        {aboutPage.sections.map((section) => (
          <RevealItem key={section.headline}>
            <Card radius="xxl" padding="lg" height="full">
              <CardContent gap="lg">
                <Heading level={2} size="xl">
                  {formatText(section.headline)}
                </Heading>
                <Stack gap="md">
                  {section.copy.map((paragraph) => (
                    <Text key={paragraph} variant="prose">
                      {formatText(paragraph)}
                    </Text>
                  ))}
                </Stack>
              </CardContent>
            </Card>
          </RevealItem>
        ))}
      </Grid>
    </RevealGroup>
  );
}
